import { useMemo, useState } from 'react';
import styled from 'styled-components';

import { Flex, Space, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import { useModalContext } from '@/components/Modal/Modal';
import Heading from '@/components/Typography/Heading';
import { modalStyle } from '@/styles/style';

import AnalysisTriggerOptions from '../../components/AnalysisTriggerOptions';
import type { ImportRuleT, ImportTemplateT } from '../types/types';

type Props = {
  importRule: ImportRuleT;
  loading: boolean;
  template: ImportTemplateT;
  confirmOptions: {
    label: string;
    callback: (i: ImportRuleT) => void;
  };
};

const IntercomTriggerSettingModal = (props: Props) => {
  const { closeModal } = useModalContext();
  const [importRule, setImportRule] = useState<ImportRuleT>(props.importRule);

  const disabled = useMemo(() => {
    if (
      props.importRule.tag === props.template.tag.import[0] ||
      props.importRule.tag === props.template.tag.doNotImport[0]
    ) {
      if (
        !props.importRule.tag_names ||
        props.importRule.tag_names.length < 1
      ) {
        return true;
      }
    }
    return false;
  }, [
    props.importRule.tag,
    props.importRule.tag_names,
    props.template.tag.doNotImport,
    props.template.tag.import,
  ]);

  return (
    <Style>
      <Heading type="h2">AI analysis trigger options</Heading>
      <Space h={32} />
      <AnalysisTriggerOptions
        importRule={importRule}
        setImportRule={setImportRule}
        template={props.template}
      />
      <Space h="40px" />
      <Flex j="flex-end" g="6px">
        <Button
          sizeType="m"
          variant="ghost"
          onClick={() => {
            closeModal();
          }}
        >
          Cancel
        </Button>
        <Button
          sizeType="m"
          isLoading={props.loading}
          onClick={() => props.confirmOptions.callback(importRule)}
          disabled={disabled}
        >
          {props.confirmOptions.label}
        </Button>
      </Flex>
    </Style>
  );
};

const Style = styled(VFlex)`
  width: 600px;
  padding: 32px;
  ${modalStyle};
`;

export default IntercomTriggerSettingModal;
